// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute } from '@tanstack/react-router';

// material ui
import { Stack } from '@mui/material';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';

// feature-components
import DeviceCreatePage from '@/features/devices/components/DeviceCreatePage';

export const Route = createFileRoute('/$accountId/_admin/devices/register')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('units-gateways-sensors');

  return (
    <PageContainer maxWidth="xl" sx={{ py: 2 }}>
      <Stack spacing={2}>
        <PageHeader
          title={t('devices.createTitle')}
          description={t('devices.createDescription')}
        />
        <DeviceCreatePage />
      </Stack>
    </PageContainer>
  );
}
